module.exports = __webpack_public_path__ + "static/media/HCMM234.df2c6fb9.jpg";